import React from 'react'
import ReactDOM from 'react-dom'

import PageoscopeLive from './PageoscopeLive'

const el = document.getElementById('root');
ReactDOM.render(<PageoscopeLive env={el.getAttribute('data-env')} devmode={el.getAttribute('data-devmode')} params={el.getAttribute('data-params')} mode={el.getAttribute('data-mode')} />, document.getElementById('root'))
